export interface CourseCertificateInfo {
  studentName: string;
  studentCourseName: string;
  certificateOrganizationName: string;
  certificateIssueDate: string;
  originalVersionImageUrls: string[];
  originalVersionPdfUrl: string;
  socialVersionImageUrl: string;
}

export class CourseCertificateModel {
  studentName: string;

  studentCourseName: string;

  certificateOrganizationName: string;

  certificateIssueDate: string;

  originalVersionImageUrls: string[];

  originalVersionPdfUrl: string;

  socialVersionImageUrl: string;

  constructor(courseCertificateInfo: CourseCertificateInfo) {
    this.studentName = courseCertificateInfo.studentName;
    this.studentCourseName = courseCertificateInfo.studentCourseName;
    this.certificateOrganizationName = courseCertificateInfo.certificateOrganizationName;
    this.certificateIssueDate = courseCertificateInfo.certificateIssueDate;
    this.originalVersionImageUrls = courseCertificateInfo.originalVersionImageUrls || [];
    this.originalVersionPdfUrl = courseCertificateInfo.originalVersionPdfUrl;
    this.socialVersionImageUrl = courseCertificateInfo.socialVersionImageUrl;
  }
}
